import React, { useEffect, useState } from 'react';
import { getConsent, setConsent } from '@/lib/analytics';
import { LogoMark } from './Logo';

const REOPEN_EVENT = 'zeevogo:open-cookie-settings';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(getConsent() === null);

    const reopen = () => setVisible(true);
    window.addEventListener(REOPEN_EVENT, reopen);
    return () => window.removeEventListener(REOPEN_EVENT, reopen);
  }, []);

  if (!visible) return null;

  const handleChoice = (granted) => {
    setConsent(granted);
    setVisible(false);
  };

  return (
    <div
      className="fixed bottom-6 left-6 right-6 md:left-auto md:right-6 md:w-[420px] z-50 rounded-[18px] p-5"
      style={{ background: '#2d2a24', color: '#fff', boxShadow: '0 20px 50px rgba(0,0,0,.28)' }}
    >
      <div className="flex items-start gap-3 mb-4">
        <LogoMark size={28} ink="#fff" fill="transparent" style={{ flexShrink: 0, marginTop: 2 }} />
        <p className="text-sm m-0" style={{ color: '#b4ae9f' }}>
          Zeevogo uses cookies to operate this website securely and understand how it's used, so we can continue
          improving your experience. You can accept all cookies or decline non-essential ones at any time.
        </p>
      </div>
      <div className="flex gap-3 justify-end">
        <button
          type="button"
          onClick={() => handleChoice(false)}
          className="h-10 px-5 rounded-full text-sm font-medium border transition-colors"
          style={{ background: 'transparent', color: '#fff', borderColor: 'rgba(255,255,255,.3)' }}
        >
          Decline
        </button>
        <button
          type="button"
          onClick={() => handleChoice(true)}
          className="h-10 px-5 rounded-full text-sm font-medium text-black transition-all"
          style={{ background: '#e08e0b' }}
        >
          Accept All
        </button>
      </div>
    </div>
  );
};

export const openCookieSettings = () => window.dispatchEvent(new Event(REOPEN_EVENT));

export default CookieConsent;
